export const getDefaultSettingPath = (canAccessAiUsage: boolean): string =>
  canAccessAiUsage ? "/setting/ai-usage" : "/setting/account";
